export const ANALYTICS_BASE_URL = process.env.REACT_APP_ANALYTICS_BASE_URL;
export const ANALYTICS_KPI_URL = process.env.REACT_APP_ANALYTICS_KPI_URL;
export const ANALYTICS_KPI_TITLES_URL = process.env.REACT_APP_ANALYTICS_KPI_TITLES_URL;
export const APP_PDC_URL = process.env.REACT_APP_PDC_URL;
export const API_PDC_URL_V1 = process.env.REACT_APP_API_PDC_URL_V1;
export const API_PDC_URL_V0 = process.env.REACT_APP_API_PDC_URL_V0;
export const API_PDC_URL_V2 = process.env.REACT_APP_API_PDC_URL_V2;
export const PDC_URL_V2 = process.env.REACT_APP_PDC_URL_V2;
export const API_PDC_URL_V3 = process.env.REACT_APP_API_PDC_URL_V3;
export const API_PRECOG_URL_V1 = process.env.REACT_APP_API_PRECOG_URL_V1;
export const API_CAPTCHA_SIGNUP_URL = process.env.REACT_APP_API_CAPTCHA_SIGNUP_URL;

export const API_SIGNATURE_URL = process.env.REACT_APP_API_SIGNATURE_URL;

export const ENV = process.env.REACT_APP_ENV;

export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const BRANCH_NAME = process.env.REACT_APP_BRANCH_NAME;
export const B2BREAD_API_URL_V2 = process.env.REACT_APP_B2BREAD_API_URL_V2;
export const OCT_INVOICE_TRADING_URL = process.env.REACT_APP_OCT_INVOICE_TRADING_URL;

export const TSPAY_GATEWAY_URL = process.env.REACT_APP_TSPAY_GATEWAY_URL;

export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;
export const ELEVIO_ACCOUNT = process.env.REACT_APP_ELEVIO_ACCOUNT;
export const ELEVIO_SECRET = process.env.REACT_APP_ELEVIO_SECRET;
export const ENABLE_DISPLAY_REDIRECT_PAGE = process.env.REACT_APP_ENABLE_DISPLAY_REDIRECT_PAGE;
export const FEATURE_TOGGLE_ADD_NEW_DEADLINES = process.env.REACT_APP_FEATURE_TOGGLE_ADD_NEW_DEADLINES;
export const FEATURE_TOGGLE_ANALYTICS = process.env.REACT_APP_FEATURE_TOGGLE_ANALYTICS;
export const FEATURE_TOGGLE_CASH_FLOW = process.env.REACT_APP_FEATURE_TOGGLE_CASH_FLOW;
export const FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS = process.env.REACT_APP_FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS;
export const FEATURE_TOGGLE_ITEM_ACTIVITIES = process.env.REACT_APP_FEATURE_TOGGLE_ITEM_ACTIVITIES;
export const FEATURE_TOGGLE_DEADLINES_EDIT_SPLIT = process.env.REACT_APP_FEATURE_TOGGLE_DEADLINES_EDIT_SPLIT;
export const FEATURE_TOGGLE_DEADLINES_MERGE = process.env.REACT_APP_FEATURE_TOGGLE_DEADLINES_MERGE;
export const FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE = process.env.REACT_APP_FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE;
export const FEATURE_TOGGLE_ACTIVATION_DBX = process.env.REACT_APP_FEATURE_TOGGLE_ACTIVATION_DBX;
export const FEATURE_TOGGLE_IMPOSTE = process.env.REACT_APP_FEATURE_TOGGLE_IMPOSTE;
export const FEATURE_TOGGLE_SELFSEND = process.env.REACT_APP_FEATURE_TOGGLE_SELFSEND;
export const FEATURE_TOGGLE_LINKED_DOCUMENTS_SECTION = process.env.REACT_APP_FEATURE_TOGGLE_LINKED_DOCUMENTS_SECTION;
export const FEATURE_TOGGLE_AUTHORIZE = process.env.REACT_APP_FEATURE_TOGGLE_AUTHORIZE;
export const FEATURE_TOGGLE_NOTIFICATION = process.env.REACT_APP_FEATURE_TOGGLE_NOTIFICATION;
export const FEATURE_TOGGLE_ASK = process.env.REACT_APP_FEATURE_TOGGLE_ASK;
export const FEATURE_TOGGLE_SETTINGS = process.env.REACT_APP_FEATURE_TOGGLE_SETTINGS;
export const FEATURE_TOGGLE_INCASSA_SUBITO = process.env.REACT_APP_FEATURE_TOGGLE_INCASSA_SUBITO;
export const FEATURE_TOGGLE_TSPAY = process.env.REACT_APP_FEATURE_TOGGLE_TSPAY;
export const FEATURE_TOGGLE_DEADLINES_CARD = process.env.REACT_APP_FEATURE_TOGGLE_DEADLINES_CARD;
export const FEATURE_TOGGLE_FULFILMENTS = process.env.REACT_APP_FEATURE_TOGGLE_FULFILMENTS;
export const FEATURE_TOGGLE_RECONCILIATION = process.env.REACT_APP_FEATURE_TOGGLE_RECONCILIATION;
export const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;
export const HOTJAR_SITE_SNIPPET = process.env.REACT_APP_HOTJAR_SITE_SNIPPET;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const TSDIGITAL_ENDPOINT = process.env.REACT_APP_TSDIGITAL_ENDPOINT;
export const TSDIGITAL_PORTALE_PUBLIC_URL = process.env.REACT_APP_TSDIGITAL_PORTALE_PUBLIC_URL;
export const UNDER_MAINTENANCE = process.env.REACT_APP_UNDER_MAINTENANCE;
export const USER_READ_API_URL = process.env.REACT_APP_USER_READ_API_URL;
export const USER_READ_API_URL_V3 = process.env.REACT_APP_USER_READ_API_URL_V3;
export const IFRAME_DIGITALSIGN_URL = process.env.REACT_APP_IFRAME_DIGITALSIGN_URL;
export const API_TYPES_URL = process.env.REACT_APP_API_TYPES;
export const FEATURE_TOGGLE_DOCUMENTS_FILENAME_SECTION = process.env.REACT_APP_FEATURE_TOGGLE_DOCUMENTS_FILENAME_SECTION;
export const FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY = process.env.REACT_APP_FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY;
export const FEATURE_TOGGLE_CLIENT_CARD = process.env.REACT_APP_FEATURE_TOGGLE_CLIENT_CARD;
export const FEATURE_TOGGLE_CLIENT_CARD_SECTION = process.env.REACT_APP_FEATURE_TOGGLE_CLIENT_CARD_SECTION;
export const B2B_AUTH_SERVICE_URL = process.env.REACT_APP_B2B_AUTH_SERVICE_URL;
export const TSDIGITAL_API_URL = process.env.REACT_APP_TSDIGITAL_API_URL;
export const API_ASK_TEMPLATES = process.env.REACT_APP_API_ASK_TEMPLATES;
export const FEATURE_TOGGLE_DOTS = process.env.REACT_APP_FEATURE_TOGGLE_DOTS;
export const FEATURE_TOGGLE_PARTIES = process.env.REACT_APP_FEATURE_TOGGLE_PARTIES;
export const FEATURE_TOGGLE_TSPAY_ONBOARDING = process.env.REACT_APP_FEATURE_TOGGLE_TSPAY_ONBOARDING;
export const TSPAY_CONFIG_NEW_URL = process.env.REACT_APP_API_TSPAY_CONFIG_NEW_URL;
export const TSPAY_START_ONBOARDING = process.env.REACT_APP_API_TSPAY_START_ONBOARDING;
export const FEATURE_TOGGLE_PRE_COG = process.env.REACT_APP_FEATURE_TOGGLE_PRE_COG;
export const FEATURE_TOGGLE_ONLY_DEV = process.env.REACT_APP_FEATURE_TOGGLE_ONLY_DEV;
export const FEATURE_TOGGLE_ONLY_DEV_TEST = process.env.REACT_APP_FEATURE_TOGGLE_ONLY_DEV_TEST;
export const RESEND_TSPAY_ONBOARDING_MAIL_URL = process.env.REACT_APP_API_RESEND_TSPAY_ONBOARDING_MAIL_URL;
export const API_PARTY_REGISTRY_BASE_URL = process.env.REACT_APP_API_API_PARTY_REGISTRY_BASE_URL;
export const FEATURE_TOGGLE_DEADLINES_ACTIVITIES = process.env.REACT_APP_FEATURE_TOGGLE_DEADLINES_ACTIVITIES;
export const FEATURE_TOGGLE_TOUR = process.env.REACT_APP_FEATURE_TOGGLE_TOUR;

export const FEATURE_TOGGLE_REPORTS = process.env.REACT_APP_FEATURE_TOGGLE_REPORTS;
export const FEATURE_TOGGLE_TAX_CREDIT = process.env.REACT_APP_FEATURE_TOGGLE_TAX_CREDIT;
export const FEATURE_TOGGLE_CHART_ACCOUNTS = process.env.REACT_APP_FEATURE_TOGGLE_CHART_ACCOUNTS;
export const FEATURE_TOGGLE_ACCOUNTING = process.env.REACT_APP_FEATURE_TOGGLE_ACCOUNTING;
export const API_VAT_REGISTRY_URL = process.env.REACT_APP_API_VAT_REGISTRY_URL;
export const NEW_COOKIE_POLICY_URL = process.env.REACT_APP_NEW_COOKIE_POLICY_URL || "https://app.teamsystemdigital.com/cookie-policy/index.html";
export const COMMON_LOGIN_URL = process.env.REACT_APP_COMMON_LOGIN_URL || "https://login-dev.teamsystemdigital.com/";
export const FEATURE_TOGGLE_BUSINESS_INFORMATION = process.env.REACT_APP_FEATURE_TOGGLE_BUSINESS_INFORMATION;
export const FEATURE_TOGGLE_TO_BE_ACCOUNTANT_V2 = process.env.REACT_APP_FEATURE_TOGGLE_TO_BE_ACCOUNTANT_V2;
export const FEATURE_TOGGLE_F24 = process.env.REACT_APP_FEATURE_TOGGLE_F24;
export const F24_IFRAME_URL = process.env.REACT_APP_F24_IFRAME_URL;
export const LOGIN_METHOD = process.env.REACT_APP_LOGIN_METHOD || "ALL";
export const FEATURE_TOGGLE_MULTILANGUAGE = process.env.REACT_APP_FEATURE_TOGGLE_MULTILANGUAGE;
export const FEATURE_TOGGLE_CUSTOMER_MANAGEMENT = process.env.REACT_APP_FEATURE_TOGGLE_CUSTOMER_MANAGEMENT;
export const CUSTOMER_MANAGEMENT_URL = process.env.REACT_APP_CUSTOMER_MANAGEMENT_URL;
export const TSID_PUBLIC_URL = process.env.REACT_APP_TSID_PUBLIC_URL;
export const REGISTRY_READ_URL = process.env.REACT_APP_REGISTRY_READ_URL || "https://registry-read-dev.agyo.io/api/v2";
export const B2B_CERT_UPLOAD_URL = process.env.REACT_APP_B2B_CERT_UPLOAD_URL;
export const TSDIGITAL_PORTALE_URL = process.env.REACT_APP_TSDIGITAL_PORTALE_URL;
export const DOCUMENTS_BFF_BASEURL = process.env.REACT_APP_DOCUMENTS_BFF_BASEURL;

export const ONE_TRUST_ENABLED = process.env.REACT_APP_ONE_TRUST_ENABLED;